import { useMemo } from 'react';
import { CONTRACT_FILTERABLE_FIELDS } from '@vy/contracts-types';
import { MONGO_FILTER_OPERATORS } from '@vy/types';
import { useLabels } from '../../../../hooks/requests/use-labels';
import type { FilterField } from '../../../../components/new-design/vyTableFilter';
import { CONTRACTS_FILTER_FIELDS } from '../plans-page-utils/filter-fields-utils';

export function useContractsFilterFields(): FilterField[] {
  const { data: labelsData } = useLabels();

  return useMemo((): FilterField[] => {
    const labelsOptions = (labelsData?.labels ?? []).map((label) => ({
      value: label.id,
      label: label.name,
    }));

    if (labelsOptions.length === 0) {
      return CONTRACTS_FILTER_FIELDS;
    }

    const labelsField: FilterField = {
      id: CONTRACT_FILTERABLE_FIELDS.LABELS,
      label: 'Labels',
      inputType: 'select',
      operators: [
        { label: 'Is any of', value: MONGO_FILTER_OPERATORS.HAS_SOME },
        { label: 'Is not any of', value: MONGO_FILTER_OPERATORS.HAS_NONE },
      ],
      options: labelsOptions,
    };

    return [...CONTRACTS_FILTER_FIELDS, labelsField];
  }, [labelsData]);
}
